// extracted by mini-css-extract-plugin
export default {"login_form":"login-form_login_form__3kbd0"};